// Track how many sheets/numpads are mounted at once; toggle `body.has-sheet`
// while at least one is present so CSS can shrink the app shell.
// Mantiene anche l'ordine di apertura (per far reagire al popstate SOLO lo
// sheet in cima) e la soppressione del popstate generato dagli history.back()
// programmatici di chiusura (altrimenti chiuderebbe a cascata anche gli
// sheet sotto: es. scegli una valuta → si chiudeva l'intera modale spesa).
let count = 0
const CLASS = 'has-sheet'
let nextId = 0
const order = [] // id degli sheet montati, in ordine di apertura

export function pushSheet() {
  count++
  if (count === 1) document.body.classList.add(CLASS)
  const id = ++nextId
  order.push(id)
  return id
}

export function popSheet(id) {
  count--
  if (count <= 0) {
    count = 0
    document.body.classList.remove(CLASS)
  }
  const idx = order.indexOf(id)
  if (idx !== -1) order.splice(idx, 1)
}

export function isTopSheet(id) {
  return order.length > 0 && order[order.length - 1] === id
}

// history.back() programmatico in arrivo: il prossimo popstate va ignorato
// da tutti gli sheet. Flag letto sincronicamente da tutti i listener dello
// stesso evento, azzerato al task successivo.
let suppressPop = false
export function suppressNextPop() {
  suppressPop = true
  setTimeout(() => { suppressPop = false }, 0)
}
export function isPopSuppressed() {
  return suppressPop
}
